import type { FontConfig } from './types';

type FontLoadKeyConfig = Pick<
  FontConfig,
  | 'font'
  | 'fontStyle'
  | 'fontWeight'
  | 'renderFamily'
  | 'revision'
  | 'identityKey'
>;

/** Stable status/deduplication key for one effective face variant. */
export default function getFontLoadKey({
  font,
  fontStyle,
  fontWeight,
  renderFamily,
  revision,
  identityKey,
}: FontLoadKeyConfig) {
  const effectiveFamily = renderFamily || font.family;
  return [
    identityKey || `legacy:${font.service}:${effectiveFamily}`,
    revision || '',
    effectiveFamily,
    fontWeight || 400,
    fontStyle || 'normal',
  ].join('|');
}
